import DupontThemeProvider from './DupontThemeProvider';

export * from './DupontThemeProvider';

export default DupontThemeProvider;
